export default "__VITE_ASSET__0UxSG5mT__"